var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-341 381 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#00A6E7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-325 387c-5.5 0-10 3.6-10 8 0 2.9 1.9 5.5 5 6.9v5.1l5.3-4c5.4-.1 9.7-3.7 9.7-8 0-4.4-4.5-8-10-8zm0 14h-.3l-2.7 2v-2.4l-.6-.2c-2.7-1-4.4-3.1-4.4-5.3 0-3.3 3.6-6 8-6s8 2.7 8 6-3.6 5.9-8 5.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-330 392h10v2h-10v-2zm0 4h7v2h-7v-2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.8be6c58b.svg";
export { ForwardRef as ReactComponent };